import React, { Component } from "react";
import {
  Box,
  Table,
  TableCell,
  TableRow,
  TableHeader,
  TableBody,
  Image,
  Text
} from "grommet";

const lettersArray = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z"
];
export class WayPointRow extends Component {
  componentDidMount = () => {
    console.log("waypoin row props: ", this.props);
  };

  render() {
    const startPoint = this.props.wayPointCount * 2;
    const endPoint = this.props.wayPointCount * 2 + 1;
    const startLetter = lettersArray[startPoint];
    const endLetter = lettersArray[endPoint];
    const routeString = "From point " + startLetter + " to " + endLetter;
    const tableRow = (
      <TableRow>
        <TableCell>{routeString}</TableCell>
        <TableCell>{this.props.wayPointStartTime}</TableCell>
        <TableCell>{this.props.wayPointEndTime}</TableCell>
        <TableCell>{this.props.wayPointTimeTaken}</TableCell>
      </TableRow>
    );

    return (
      <Box alignContent="center" direction="column">
        <Text alignSelf="center">Waypoint</Text>
        <Table alignSelf="center">
          <TableHeader>
            <TableCell>Route</TableCell>
            <TableCell>Start Time</TableCell>
            <TableCell>End Time</TableCell>
            <TableCell>Total Time</TableCell>
          </TableHeader>
          <TableBody>{tableRow}</TableBody>
        </Table>
      </Box>
    );
  }
}

export default WayPointRow;
